import { render, staticRenderFns } from "./ElderlyRateLineChart.vue?vue&type=template&id=0a913a23&scoped=true&"
import script from "./ElderlyRateLineChart.vue?vue&type=script&lang=js&"
export * from "./ElderlyRateLineChart.vue?vue&type=script&lang=js&"
import style0 from "./ElderlyRateLineChart.vue?vue&type=style&index=0&id=0a913a23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a913a23",
  null
  
)

export default component.exports